import { render, staticRenderFns } from "./PromocodeForm.vue?vue&type=template&id=a0ab6b00&scoped=true&"
import script from "./PromocodeForm.vue?vue&type=script&lang=js&"
export * from "./PromocodeForm.vue?vue&type=script&lang=js&"
import style0 from "./PromocodeForm.vue?vue&type=style&index=0&id=a0ab6b00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ab6b00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src469726766/src/admin-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0ab6b00')) {
      api.createRecord('a0ab6b00', component.options)
    } else {
      api.reload('a0ab6b00', component.options)
    }
    module.hot.accept("./PromocodeForm.vue?vue&type=template&id=a0ab6b00&scoped=true&", function () {
      api.rerender('a0ab6b00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/PromocodeForm.vue"
export default component.exports